<template>
  <div class="panel-title" :class="{ 'agenda-back': isBack }" :id="id">
    <div class="title-container">
      <span class="panel-icon"
        ><img src="../../assets/images/title-icon.png" alt=""
      /></span>
      <span class="panel-txt">{{ title }}</span>
    </div>
    <div class="en-title">{{ enTitle }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PanelTitle",
  props: {
    title: String,
    enTitle: String,
    isBack: Boolean,
    customStyle: Object,
    id: String
  },
  computed: {},
  methods: {}
};
</script>
